/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React from 'react';
import PropTypes from 'prop-types';
/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/
// Components
import Icon from '../Icon';
import Autocomplete from '../Autocomplete';
// Style
import theme from '../../styles/theme';
import FormWrap from './headerSearch.style';
// Utils
import searchHelper from '../../utils/searchHelper';


const HeaderSearchForm = (props) => {
  const {
    useDarkBackground,
    open,
    setOpen,
    toggleOpen,
  } = props;

  return (
    <FormWrap
      useDarkBackground={useDarkBackground}
      open={open}
      toggleOpen={toggleOpen}
    >
      <div className="search-input">
        <div
          onClick={() => setOpen(!open)}
          aria-hidden="true"
        >
          <Icon name="search" color={useDarkBackground ? `${theme.body.dark}` : `${theme.body.light}`} />
        </div>
        {open && (
          <Autocomplete
            placeholder="Search in help center"
            onItemClick={searchHelper.onItemClick}
            onSelectItem={searchHelper.onSelectItem}
            onSubmit={searchHelper.onSubmit}
          />
        )}
      </div>
    </FormWrap>
  );
};

/*------------------------------------------------*/
/* PROP TYPES
/*------------------------------------------------*/
HeaderSearchForm.propTypes = {
  // Required props:
  open: PropTypes.bool.isRequired,
  useDarkBackground: PropTypes.bool.isRequired,
  // Required methods:
  setOpen: PropTypes.func.isRequired,
  // Optional props:
  toggleOpen: PropTypes.bool,
};

HeaderSearchForm.defaultProps = {
  toggleOpen: false,
};

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default HeaderSearchForm;
